




































import { Component, Prop, Vue } from "vue-property-decorator";
import { getHumanDateTime } from "@/utility/DateUtils";
import { SuratRujukanRalanItem } from "@/types";

@Component
export default class SuratRujukanRalanPreviewDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ default: null }) readonly rujukan!: SuratRujukanRalanItem | null;

  get dialog() {
    return this.value;
  }

  set dialog(val: boolean) {
    this.$emit("input", val);
  }

  get sudahTtd() {
    return !!this.rujukan && Number(this.rujukan.signed) === 1;
  }

  get waktuTtd() {
    return this.rujukan ? getHumanDateTime(this.rujukan.signed_at) : "";
  }

  get daftarIsi() {
    const r = this.rujukan;
    if (!r) return [];
    return [
      { label: "Nomor", nilai: r.nomor },
      { label: "Tanggal Surat", nilai: getHumanDateTime(r.waktu) },
      { label: "Dokter Pembuat", nilai: r.dokter && r.dokter.nama },
      { label: "Faskes Tujuan", nilai: r.tujuan && r.tujuan.nama },
      { label: "Unit/ Klinik Tujuan", nilai: r.unit_tujuan_text },
      { label: "Diagnosis", nilai: r.diagnosis },
      { label: "Alasan Dirujuk", nilai: r.alasan },
      { label: "Kondisi Khusus", nilai: r.kondisi },
      { label: "Tindakan/Terapi yang telah diberikan", nilai: r.terapi_diberikan },
      { label: "Pemeriksaan Penunjang", nilai: r.penunjang },
      { label: "Tindakan/Terapi yang diharapkan", nilai: r.terapi_diharapkan }
    ];
  }
}
